import { FC, useState } from 'react';
import styled from 'styled-components';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

import { IconButton2 } from '@clatter/ui';
import { useDeepCompareMemo } from '@clatter/platform';
import { useGetEntitiesByTypeQuery } from '../../../../services';
import { CircularLoader } from '../../../../shared';


const StyledContainer = styled.div`
  margin-top: 1rem;

  .selected-table-header {
    text-transform: capitalize;
  }
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
  background-color: white;

  th,
  td {
    //border: 1px solid #ddd;
    padding: 8px;
    border: 0 solid white;
  }

  th {
    background-color: #f2f2f2;
    text-align: left;
  }

  .actions-column {
    display: flex;
    justify-content: flex-end;
    gap: 20px;
  }

  button {
    cursor: pointer;
  }
`;

const StyledMultiActionContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const StyledSearchInput = styled.input`
  margin-bottom: 10px;
  padding: 8px;
  width: 100%;
  box-sizing: border-box;
`;

const ActionButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  padding: 4px;
  margin: 0 2px;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

interface RelationFieldInputProps {
  field: any;
  values: any[];
  onChange?: any;
}

const getLabelFromItem = (item: any) =>
  item?.displayName ||
  item?.display_name ||
  item?.name ||
  item?.title ||
  (item?.first_name && `${item.first_name} ${item?.last_name}`) ||
  '';

export const RelationFieldInput: FC<RelationFieldInputProps> = ({ field, values, onChange }) => {
  const { data: entitiesToAdd, isLoading: isCollectionDataLoading } = useGetEntitiesByTypeQuery({
    entityType: field?.foreign_type,
  });

  const [selectedIds, setSelectedIds] = useState<any[]>([]);
  const [searchTerm, setSearchTerm] = useState('');

  const availableItems = useDeepCompareMemo(
    () =>
      entitiesToAdd?.filter(
        (item: any) =>
          !values.some((value: any) => value?.ID === item?.id) &&
          getLabelFromItem(item).toLowerCase().includes(searchTerm.toLowerCase()),
      ),
    [entitiesToAdd, values],
  );

  const handleAddItem = (itemId: number) => {
    onChange({ type: 'add', payload: { edgeType: field?.foreign_type, itemId: itemId } });
  };

  const handleRemoveItem = (itemId: number) => {
    onChange({ type: 'remove', payload: { edgeType: field?.foreign_type, itemId: itemId } });
  };

  const handleRemoveSelectedItems = () => {
    // @todo
    setSelectedIds([]);
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  const handleCheckboxChange = (itemId: number) => {
    setSelectedIds((prev) => (prev.includes(itemId) ? prev.filter((id) => id !== itemId) : [...prev, itemId]));
  };

  const moveItem = (direction: 'up' | 'down') => {
    // @todo
  };

  return (
    <StyledContainer>
      <div>
        <label>{field?.label || field?.name}</label>

        <StyledSearchInput type="text" placeholder="Search..." value={searchTerm} onChange={handleSearchChange} />

        {isCollectionDataLoading ? (
          <CircularLoader />
        ) : (
          <StyledTable>
            <thead>
              <tr>
                <th>Name</th>
                <th className="actions-column">Actions</th>
              </tr>
            </thead>
            <tbody>
              {(availableItems || []).map((item: any) => (
                <tr key={item.id}>
                  <td>{getLabelFromItem(item)}</td>
                  <td className="actions-column">
                    {/*//@ts-ignore*/}
                    <IconButton2 onClick={() => handleAddItem(item.id)}>
                      <AddIcon />
                    </IconButton2>
                  </td>
                </tr>
              ))}
            </tbody>
          </StyledTable>
        )}
      </div>
      <div>
        <h4 className="selected-table-header">Your Selected {field?.collection}</h4>

        {/*<StyledMultiActionContainer>*/}
        {/*  <ActionButton type="button" onClick={() => moveItem('up')} disabled={selectedIds?.length === 0}>*/}
        {/*    <ArrowUpwardIcon />*/}
        {/*  </ActionButton>*/}
        {/*  <ActionButton type="button" onClick={() => moveItem('down')} disabled={selectedIds?.length === 0}>*/}
        {/*    <ArrowDownwardIcon />*/}
        {/*  </ActionButton>*/}
        {/*  <ActionButton type="button" onClick={handleRemoveSelectedItems} disabled={selectedIds?.length === 0}>*/}
        {/*    <DeleteIcon />*/}
        {/*  </ActionButton>*/}
        {/*</StyledMultiActionContainer>*/}

        <StyledTable>
          <thead>
            <tr>
              {/*<th>*/}
              {/*  <input*/}
              {/*    type="checkbox"*/}
              {/*    onChange={() => setSelectedIds(addedItemIds.length === selectedIds.length ? [] : addedItemIds)}*/}
              {/*    checked={addedItemIds.length > 0 && addedItemIds.length === selectedIds.length}*/}
              {/*    disabled={addedItemIds.length === 0}*/}
              {/*  />*/}
              {/*</th>*/}
              <th>Name</th>
              <th className="actions-column">Actions</th>
            </tr>
          </thead>
          <tbody>
            {values.map((item) => (
              <tr key={item?.id || item?.ID}>
                {/*<td>*/}
                {/*  <input*/}
                {/*    type="checkbox"*/}
                {/*    checked={selectedIds.includes(id)}*/}
                {/*    onChange={() => handleCheckboxChange(id)}*/}
                {/*  />*/}
                {/*</td>*/}
                <td>{getLabelFromItem(item?.Data)}</td>
                <td className="actions-column">
                  {/*//@ts-ignore*/}
                  <IconButton2 onClick={() => handleRemoveItem(item?.id || item?.ID)}>
                    <RemoveIcon />
                  </IconButton2>
                </td>
              </tr>
            ))}
          </tbody>
        </StyledTable>
      </div>
    </StyledContainer>
  );
};
